export default __webpack_public_path__ + "assets/icons/home_clearanceService.1467f50a.svg";